/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Role {
  ANY = 'ANY',
  OMNIPOTENT_ADMIN = 'OMNIPOTENT_ADMIN',
  OPERATOR = 'OPERATOR',
  AGENCY_ADMIN = 'AGENCY_ADMIN',
  AGENT = 'AGENT',
  ACCOUNT_SUPERVISOR = 'ACCOUNT_SUPERVISOR',
  EMPLOYER_ADMIN = 'EMPLOYER_ADMIN',
  EMPLOYEE = 'EMPLOYEE',
  USER = 'USER',
}
